import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=286b1e80&"
import script from "./EventDetail.vue?vue&type=script&lang=js&"
export * from "./EventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286b1e80')) {
      api.createRecord('286b1e80', component.options)
    } else {
      api.reload('286b1e80', component.options)
    }
    module.hot.accept("./EventDetail.vue?vue&type=template&id=286b1e80&", function () {
      api.rerender('286b1e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/EventDetail.vue"
export default component.exports